import React from 'react';
import './Login.css';
import GotTeaBigLogo from '../../../media/GotTeaNewLogo.svg';
import Utilities from '../../../js/Utilities';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

  // Configure FirebaseUI.
const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
    signInSuccessUrl: '/',
    // We will display Google and Facebook as auth providers.
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
  };

class Login extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            username:'',
            password:'',
            errorMsg : ''
        }
      }

    componentDidMount(){
        window.scrollTo(0, 0); 
    }

    handleUsernameChange = (e)=>{
        this.setState({ username : e.target.value, errorMsg : '' });
    }

    handlePasswordChange = (e)=>{
        this.setState({ password : e.target.value , errorMsg : ''  });
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.handleLogin();
        }
    }

    handleLogin = ()=>{
        // TODO: Make API Call to Validate Creds
        if(this.state.password !== 'GotTea@2020'){
            this.setState({ errorMsg : 'Password is Invalid'});
        } else {
            Utilities.setToken();
            window.location.href = '/';
        }
    }

    render(){
        const { errorMsg } = this.state;
        return <div className="innerPageContainer loginMainContainer">
            <div className='loginBox'>
            <div className='inputContainer'>
                <img className='logo' src={GotTeaBigLogo} alt=''/>
            </div>
            { errorMsg ? <div className='errorContainer'>{errorMsg}</div> : ''}
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
            </div>
      </div>
    }
}

export default Login;
